import styles from "./List.module.scss";

/**
 * The properties for a {@link List} component.
 */
interface IListProps<T> {
    /**
    * The list of items to display in the list component.
    */
    items: T[];

    /**
    * A function that returns a key to use in the loop for an item.
    * @param item The item.
    */
    elementKey: (item: T) => string;

    /**
    * A function that returns the element that will be used ot display the list.
    * @param item The item.
    */
    listElement: (item: T) => JSX.Element;
}

/**
 * A component which displays multiple elements in a list separated by horizontal bars.
 */
function List<T>({ items, elementKey, listElement }: Readonly<IListProps<T>>): JSX.Element {
    return (
        <ul className={styles.list}>
            {items.map(item =>
                <li key={elementKey(item)} className={styles.listItem}>{listElement(item)}</li>
            )}
        </ul>
    );
}

export { List };
